/** In-app quote flow. Set REACT_APP_AJANLAT_PAGE_URL to a full https URL if ajánlat lives on another origin. */
export const AJANLAT_PAGE_URL = process.env.REACT_APP_AJANLAT_PAGE_URL || '/ajanlat';

export function isExternalCampaignHref(to) {
  return typeof to === 'string' && /^https?:\/\//i.test(to);
}

export const CAMPAIGNS = [
  {
    id: 'route-discount',
    enabled: true,
    title: 'Ebben az irányban indul jármű – kedvezményes fuvar',
    body: 'Aktuális útvonalainkon 20% kedvezmény. Ha a fuvarod útba esik, kedvezményes áron tudunk szállítani.',
    ctaLabel: 'Ajánlatot kérek',
    ctaTo: AJANLAT_PAGE_URL,
    placements: ['home_card'],
    routes: [
      { from: 'Budapest', to: 'Győr', when: 'Ma 16:00', discountPct: 20 },
      { from: 'Pécel', to: 'Szeged', when: 'Holnap 09:00', discountPct: 20 },
      { from: 'Budapest', to: 'Bécs', when: 'Péntek 14:00', discountPct: 20 },
    ],
  },
  {
    id: 'weekend-deal',
    enabled: true,
    title: 'Hétvégi akció',
    body: 'Szombat–vasárnap bizonyos idősávokban extra kedvezmények. Érdeklődj a részletekről!',
    ctaLabel: 'Kapcsolat',
    ctaTo: '/',
    ctaState: { scrollTo: 'kapcsolat' },
    placements: ['home_card'],
  },
  {
    id: 'express-sale',
    enabled: true,
    title: 'Express szállítás akció',
    body: 'Gyors indulás, rövid határidő – kedvezményes express opció korlátozott kapacitással.',
    ctaLabel: 'Szolgáltatások',
    ctaTo: '/',
    ctaState: { scrollTo: 'szolgaltatas' },
    placements: ['home_card'],
  },
  {
    id: 'empty-run',
    enabled: true,
    title: 'Üresjáratos fuvar kedvezmény',
    body: 'Ha “üresjárat” útvonalra esik a fuvar, extra kedvezményt adunk. Kérj gyors visszahívást!',
    ctaLabel: 'Ajánlatot kérek',
    ctaTo: '/',
    ctaState: { scrollTo: 'kapcsolat' },
    placements: ['home_card'],
  },
];

